import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import TempExportTableItem from "./TempExportTableItem";
import { convertIntMoney } from "src/helper/convertCurrency";
const commonCss = { fontWeight: "bold", textAlign: "center" };

export default function ExportProductsTable({ prodList, setProdPick, onRemove, totalQty, total }) {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        position: "sticky",
        top: 0,
        border: "1px solid var(--grey)",
        borderRadius: "12px",
      }}
    >
      <Table
        sx={{ minWidth: 800 }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow sx={{ background: "var(--light-grey)" }}>
            <TableCell sx={{ ...commonCss }}>STT</TableCell>
            <TableCell sx={{ ...commonCss }}>Tên SP</TableCell>
            <TableCell sx={{ ...commonCss }}>Số lô</TableCell>
            <TableCell sx={{ ...commonCss }}>SL</TableCell>
            <TableCell sx={{ ...commonCss }}>CK (%)</TableCell>
            <TableCell sx={{ ...commonCss }}>Đơn giá (VNĐ)</TableCell>
            <TableCell sx={{ ...commonCss }}>Thành tiền (VNĐ) </TableCell>
            <TableCell sx={{ ...commonCss }}>Thao tác</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!!prodList?.length ? (
            prodList?.map((v, index) => {
              return (
                <TempExportTableItem
                  setProdPick={setProdPick}
                  key={index}
                  item={v}
                  num={index + 1}
                  handleRemove={onRemove}
                />
              );
            })
          ) : (
            <TableRow>
              <TableCell
                colSpan={8}
                align="center"
              >
                 Không có dữ liệu
              </TableCell>
            </TableRow>
          )}
          <TableRow sx={{ background: "var(--light-grey)" }}>
            <TableCell align="center"> </TableCell>
            <TableCell align="center">
              <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>Tổng</Typography>
            </TableCell>
            <TableCell align="center"> </TableCell>
            <TableCell align="center">
              <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>{totalQty ?? 0}</Typography>
            </TableCell>
            <TableCell align="center">  </TableCell>
            <TableCell align="center"> </TableCell>
            <TableCell align="center">
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                }}
              >
                {convertIntMoney(total) + " đ" ?? 0}
              </Typography>
            </TableCell>
            <TableCell align="center"> </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
